export default function Footer() {
    return (
        <footer className="border-t hairline bg-background text-foreground">
            <div className="mx-auto max-w-[1600px] px-6 md:px-10 py-16 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-10">
                <div className="md:col-span-6">
                    <h3 className="font-editorial text-5xl md:text-7xl leading-[0.9] tracking-tighter">
                        Rebuild
                        <br />
                        <span className="italic text-accent">access.</span>
                    </h3>
                    <p className="mt-6 max-w-lg text-sm text-muted-foreground">
                        Access Credit Repair is a boutique credit restoration studio based in Austin,
                        Texas. Federally compliant. Results-obsessed. Client-first.
                    </p>
                </div>
                <div className="md:col-span-2">
                    <div className="text-[11px] tracking-[0.2em] uppercase text-muted-foreground mb-4">
                        Contact
                    </div>
                    <a
                        href="tel:5127831895"
                        data-testid="footer-phone"
                        className="block font-mono-ui text-sm hover:text-accent"
                    >
                        512.783.1895
                    </a>
                    <a
                        href="mailto:accesscreditrepair@yahoo.com"
                        data-testid="footer-email"
                        className="block font-mono-ui text-sm mt-2 hover:text-accent break-all"
                    >
                        accesscreditrepair@yahoo.com
                    </a>
                </div>
                <div className="md:col-span-2">
                    <div className="text-[11px] tracking-[0.2em] uppercase text-muted-foreground mb-4">
                        Hours
                    </div>
                    <div className="font-mono-ui text-sm">Mon — Fri</div>
                    <div className="font-mono-ui text-sm text-muted-foreground">9:00 – 18:00 CST</div>
                    <div className="font-mono-ui text-sm mt-3">Sat</div>
                    <div className="font-mono-ui text-sm text-muted-foreground">By appointment</div>
                </div>
                <div className="md:col-span-2">
                    <div className="text-[11px] tracking-[0.2em] uppercase text-muted-foreground mb-4">
                        Compliance
                    </div>
                    <div className="font-mono-ui text-xs text-muted-foreground leading-relaxed">
                        CROA compliant.
                        <br />
                        No upfront fees.
                        <br />
                        Written contract.
                        <br />3-day right to cancel.
                    </div>
                </div>
            </div>
            <div className="border-t hairline">
                <div className="mx-auto max-w-[1600px] px-6 md:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[11px] tracking-[0.18em] uppercase text-muted-foreground">
                    <div>© {new Date().getFullYear()} Access Credit Repair. All rights reserved.</div>
                    <div className="font-mono-ui normal-case tracking-normal">
                        Austin · Texas · United States
                    </div>
                </div>
            </div>
        </footer>
    );
}
